/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  width: 100%;

  .layers-container {
    width: 100%;
    height: 100%;
    /* min-height: ${({ countLayers }) =>
      countLayers ? countLayers * 50 + 30 + 'px' : 'auto'}; */
    max-height: 88vh;
    overflow: auto;
    @media (max-width: 768px) {
      max-height: 85vh;
    }
  }

  .addlayer-mobile {
    position: absolute;
    right: 0;
    top: 14px;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    color: #3c71dd;
  }
`;
